import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddReportTaskPage } from "./add-report-task/add-report-task.page";
import { EditReportTaskPage } from "./edit-report-task/edit-report-task.page";

import { ReportTaskPage } from "./report-task.page";

const routes: Routes = [
  {
    path: "",
    component: ReportTaskPage,
  },
  {
    path: "edit-report-task/:ReportId/:ReportTaskId",
    component: EditReportTaskPage,
    data: {
      breadcrumb: 'REPORT_TASK.EDIT_TASK'
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportTaskPageRoutingModule {}
